"use client"

import { useState, useCallback, useRef, useEffect } from "react"
import { useRouter } from "next/navigation"
import { Search } from "lucide-react"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import Sentry from '@/lib/sentry-safe'

export function SoundsNav404() {
  const router = useRouter()
  const [query, setQuery] = useState("")
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault()
    if (query.trim()) {
      router.push(`/sounds?q=${encodeURIComponent(query.trim())}`)
    }
  }, [query, router])

  return (
    <form onSubmit={handleSubmit} className="space-y-2">
      <label htmlFor="404-search" className="text-sm text-[var(--tls-fg-muted)] block">
        Search for a sound:
      </label>
      <div className="flex gap-2">
        <Input
          id="404-search"
          ref={inputRef}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Star Wars, Minecraft, Portal..."
          aria-label="Search for Tesla lock sounds"
        />
        {/* One accent-filled primary per panel — the 404 panel already spends
            it on "Browse sounds", so this is the outlined secondary icon
            button (pill radius, 44px target). */}
        <Button
          type="submit"
          variant="outline"
          size="icon"
          aria-label="Search sounds"
        >
          <Search className="size-4" />
        </Button>
      </div>
    </form>
  )
}
